<!--公用头部-->
<!--设备分组仅普通管理员权限-->

<template>
	<div class="container-l headerl" :style="{'background': getBackground,'background-size': 'auto 38px'}">
		<h1></h1>
		<el-menu
		  :default-active="$route.path"
		  class="el-menu-demo"
		  mode="horizontal"
		  :router="true"
		  background-color="#133169"
		  text-color="#7fd5cc"
		  active-text-color="#eee">
		
		<!-- 1、数据中心
			2、工作台、实时监控
			3、历史数据
			4、设备监控
				机柜详情、UPS详情、配电详情、大型空调、动力环境
			5、设备管理
				设备绑定、采集设备管理、终端类别、固件升级
			6、告警管理
				告警统计、告警管理、机柜批量阈值、机柜单个阈值、动环批量阈值、动环单个阈值
			7、资产管理
				资产管理、厂商管理、维保单位管理
			8、系统管理
				用户管理、管理员及用户管理、产品介绍及公司动态、角色管理、菜单管理

			固有菜单
			退出、个人资料、重置密码、账号移交 -->


			<div class="fl clearfix" v-for="(menulevel1,index,key) in usermenu" :key="key">
				<el-menu-item v-if="menulevel1.children.length==0" :index="menulevel1.link" @click="changeStoreMenu(menulevel1)"
				:key="menulevel1.id">{{menulevel1.name}}</el-menu-item>
				<el-submenu v-if="menulevel1.children.length!=0 && menulevel1.name!='系统管理'" :key="menulevel1.id" @click="changeStoreMenu(menulevel1)"
				 :index="menulevel1.name">					
					<template slot="title">{{menulevel1.name}}</template>					
					<el-menu-item v-for="(menulevel2,index2) in menulevel1.children" :index="menulevel2.link" @click="changeStoreMenu(menulevel2)"
					:key="index2" v-text="menulevel2.name"></el-menu-item>					
				</el-submenu>
			</div>
		  
		<el-menu-item index="3-1" class="submenu_s" @click="logout()">
			<i class="fa fa-power-off"></i>
			退出
		</el-menu-item>
		<el-submenu class="submenu_s" index="">	    
		  	
			<template slot="title">
				<span class="nick" v-text="'' + $store.state.userInfo.real_name"></span>
			</template>
			
		    <el-menu-item index="/personalData">个人资料</el-menu-item>
		    <el-menu-item index="/resetPass">重置密码</el-menu-item>
			<el-menu-item index="/accountTransfer">账户移交</el-menu-item>
		  	<el-menu-item v-if="systemItem.children && systemItem.children.length" v-for="(menulevel2,index2) in systemItem.children" :index="menulevel2.link"
			  :key="index2" v-text="menulevel2.name"></el-menu-item>
		  	
		  </el-submenu>


			
	</el-menu>

	</div>

</template>
<script>
export default {
	mounted(){
	  	this.$nextTick(function(){
			  this.getMenu();
	  	})
	  	
	  },
  data(){
  	return {
      isLogouting: false,
      activeRoom:{},
	  administrators:this.getCookie('administrators'),
	  usermenu: [],
	  systemItem: {}
	}
  },
  computed:{
	  getBackground(){
		 return 'url('+this.$store.state.domain3+'logo3.png) #133169 no-repeat 25px'
	 },
  },
  methods:{
  	handleSelect(key, keyPath) {
        this.$router.push(keyPath);
	 },
	//  点击菜单，保存当前MENU对象
	 changeStoreMenu(menu){
		let expireDays = 1000 * 60 * 60 * 24 * 15;	
		this.setCookie('currentMenuId',menu.id,expireDays);	 
	 },
	 
/*	changeRoom(item){
		this.activeRoom = item;
		let expireDays = 1000 * 60 * 60 * 24 * 15;
                
                    this.setCookie('accountId',this.getCookie('accountId'),expireDays);
                    this.setCookie('real_name',this.getCookie('real_name'),expireDays);
                    this.setCookie('administrators',this.getCookie('administrators'),expireDays);
                    this.setCookie('token', this.getCookie('token'), expireDays);
		let userInfo= { //保存用户信息
				        real_name: this.getCookie('real_name'),
				        token: this.getCookie('token'),
				        accountId: this.getCookie('accountId'),
				        administrators: this.getCookie('administrators'),
				    }
            		
             //提交mutation到Store
      			this.$store.commit('updateUserInfo', userInfo); 
	},*/

	getMenu(){
		let getMenuParams={
			uid:this.getCookie('uid'),
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		this.sign2(getMenuParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/Action/roleaction",this.$qs.stringify(getMenuParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code==200){
				this.usermenu = res.data.data || [];
				// 子传父菜单数据
				this.$emit('headerChildPara',this.usermenu);
				
				var that = this;
				this.usermenu.filter(function (value){					
					if(value.name=='系统管理'){
						that.systemItem = value;						
					}										
				})
			}else if(res.data.code==10008){
				this.isLogouting = true;
				this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
			}else{
				//console.log(res.data.msg);
			}
		});
	},
  	logout(){

  		let logoutRequestParams={
  			uid:this.getCookie('uid'),
	  		timestamp:Date.parse( new Date()),
	  		terminalId:4,
	  		username:this.getCookie('username')
  		};
  		this.sign(logoutRequestParams);
  		this.$ajax.post(this.$store.state.domain+"/Home/LoginOut/LoginOut",this.$qs.stringify(logoutRequestParams),{
            emulateJSON: true
        }).then(res=>{
        	if(res.data.code==0){
        		//console.log("退出成功");
        	}else if(res.data.code==10008){
        		this.isLogouting = true;
			      this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
        	}else{
        		//console.log(res.data.msg);
        	}

  		});

      //删除cookie并跳到登录页
      this.isLogouting = true;
      this.delCookie('username');

      this.$router.push('/login/');
      this.isLogouting = false;
		this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);

   },
},


}
</script>

<style scoped="scoped">

</style>



// WEBPACK FOOTER //
// src/components/Header.vue